import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout/Layout";
import ContentHeader from "../../components/MyContent/ContentHeader";
import ContentDetails from "../../components/MyContent/ContentDetails";
import LoadingState from "../../components/Common/LoadingState";
import BackLink from "../../components/Common/BackLink";
import { useMyContentData } from "../../hooks/useMyContentData";

const MyContentEdit = () => {
    const { t } = useTranslation();
    const { contentId = "" } = useParams();
    const {
        navigate,
        selectedItem,
        isLoading,
        isDeleting,
        cleanupPendingUploads,
        handleUpdate,
        handleDelete,
        handleMediaUploaded,
    } = useMyContentData(contentId);

    return (
        <Layout activeLabel="My content">
            <div>
                <BackLink label={t("MY_CONTENT_BACK_TO_LIST")} onClick={() => selectedItem && navigate(`/my-content/${selectedItem.id}`)} />

                {isLoading ? (
                    <LoadingState message={t("MY_CONTENT_LOADING")} />
                ) : selectedItem ? (
                    <>
                        <div className="mt-4">
                            <ContentHeader
                                title={selectedItem.title}
                                subtitle={selectedItem.date ? `${t("MY_CONTENT_POSTED_ON")} ${selectedItem.date}` : ""}
                            />
                        </div>
                        <div className="mt-8">
                            <ContentDetails
                                item={selectedItem}
                                isEditing
                                onEdit={() => navigate(`/my-content/${selectedItem.id}/edit`)}
                                onCancel={async () => {
                                    await cleanupPendingUploads();
                                    navigate(`/my-content/${selectedItem.id}`);
                                }}
                                onSave={handleUpdate}
                                onDelete={handleDelete}
                                isDeleting={isDeleting}
                                onMediaUploaded={handleMediaUploaded}
                            />
                        </div>
                    </>
                ) : (
                    <div className="mt-8 rounded-md border border-slate-200 bg-input-bg px-6 py-8 text-sm text-slate-500">
                        {t("MY_CONTENT_ERROR_LOAD_ITEM")}
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default MyContentEdit;
